<template>
  <ul id="slide-out" class="sidenav sidenav-fixed">
    <li class="indigo">
      <div class="user-view">
        <a href="#user"><img class="circle" src="https://materializecss.com/images/yuna.jpg"></a>
        <a href="#name"><span class="white-text name">John Doe</span></a>
        <a href="#email"><span class="white-text email">jdandturk@gmail.com</span></a>
      </div>
    </li>
    <li>
      <ul class="collapsible" data-collapsible="accordion">
        <li class="">
          <a class="waves-effect" href="#">
            Dashboard
            <i class="fas fa-tachometer-alt"></i>
          </a>
        </li>
        <li class="">
          <a class="collapsible-header waves-effect">
            Configuration
            <i class="material-icons">settings</i>
          </a>
          <div class="collapsible-body" style="display: none; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px;">
            <ul>
              <li>
                <a class="waves-effect" style="text-decoration: none;" href="#!">Seller</a>
              </li>

              <li>
                <a class="waves-effect" style="text-decoration: none;" href="#!">Customer</a>
              </li>
            </ul>
          </div>
        </li>
        <li class="">
          <a class="collapsible-header waves-effect">
            Configuration
            <i class="material-icons">settings</i>
          </a>
          <div class="collapsible-body" style="display: none; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px;">
            <ul>
              <li>
                <a class="waves-effect" style="text-decoration: none;" href="#!">Seller</a>
              </li>

              <li>
                <a class="waves-effect" style="text-decoration: none;" href="#!">Customer</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import * as M from 'materialize-css'

export default {
  name: 'app-side-bar',
  mounted () {
    var elems = document.querySelectorAll('.sidenav')
    M.Sidenav.init(elems)

    elems = document.querySelectorAll('.collapsible')
    M.Collapsible.init(elems)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue